import { render, staticRenderFns } from "./PatientAllDetailPage.vue?vue&type=template&id=3e766420&scoped=true"
import script from "./PatientAllDetailPage.vue?vue&type=script&lang=js"
export * from "./PatientAllDetailPage.vue?vue&type=script&lang=js"
import style0 from "./PatientAllDetailPage.vue?vue&type=style&index=0&id=3e766420&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e766420",
  null
  
)

export default component.exports